import { Helmet } from 'react-helmet';

export const PageSearch = () => {
  return (
    <>
      <Helmet>
        <title>검색 결과</title>
      </Helmet>
      <p>검색 결과가 없습니다</p>
    </>
  )
}